import { staticFile } from "remotion";

export const getMediaSrc = (originalSrc: string) => {
  const plainSrcs = ["data", "http"];

  return plainSrcs.some((src) => originalSrc.startsWith(src))
    ? originalSrc
    : staticFile(originalSrc);
};
